<div class="suif-panel forgot-password" (appOnEnter)="form.emailAddress && submit()">

    <h1 class="suif-panel-title-dark">Forgot Password</h1>

    <div class="forgot-password-info" atid="forgot-password-section">

        <app-message-box *ngIf="errors.unexpectedError" unexpectedError></app-message-box>
        <app-message-box *ngIf="errors.serviceUnavailable" serviceUnavailable></app-message-box>
        <app-message-box *ngIf="errors.validationError" validationError></app-message-box>

        <h3 class="suif-h3">Enter your Email</h3>

        <p>After submitting your information, you will receive an email with further instructions to reset your password.</p>

        <app-input fieldId="username" label="Account Email Address" [(ngModel)]="form.emailAddress" type="email" inputmode="email"
                   [errors]="errors.fieldErrors.emailAddress" isRequired autoFocus></app-input>

        <div class="button-row">
            <app-wait-button (onClick)="submit()" cssClass="btn btn-verty" [waiting]="submitting"
                             label="Reset Password" [isDisabled]="!form.emailAddress"></app-wait-button>
        </div>

        <div class="suif-body-copy">
            Can't access your email account? <a routerLink="/account-recovery-workflow">Try to Recover Your Account</a>
        </div>
    </div>
</div>
